import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const Label = ({ ariaLabel, content, size, type, className }) => {
	const labelCx = cx(
		styles.label,
		styles[type],
		styles[`size_${size}`],
		className
	);

	return (
		<div className={labelCx}>
			{ariaLabel && <div className={styles.screenreaderText}>{ariaLabel}</div>}
			{content}
		</div>
	);
};

Label.propTypes = {
	ariaLabel: PropTypes.string,
	content: PropTypes.node.isRequired,
	size: PropTypes.oneOf(['large', 'small']),
	className: PropTypes.string,
	type: PropTypes.oneOf(['date'])
};

export default Label;
